import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CONTACT_DATA } from '../../Data/data.service';
import { SeoService } from '../../Shared/seo/seo.service';

interface PlanDetails {
  name: string;
  monthly: string;
  yearly: string;
  features: string[];
}

const PLAN_CATALOG: Record<string, PlanDetails> = {
  Basic: { name: 'Basic', monthly: '5k', yearly: '50k', features: ['5 apps', 'unlimited users'] },
  Standard: { name: 'Standard', monthly: '10k', yearly: '100k', features: ['All apps'] },
  Custom: {
    name: 'Custom',
    monthly: '10k',
    yearly: '100k',
    features: ['All apps', 'Multi company', 'External API', '+ customization charges apply'],
  },
};

@Component({
  selector: 'app-buy-now-page',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './buy-now-page.html',
  styleUrls: ['./buy-now-page.css'],
})
export class BuyNowPageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private seo = inject(SeoService);

  contactData = CONTACT_DATA;

  plan: PlanDetails = PLAN_CATALOG['Standard'];
  isYearly = false;

  companyName = '';
  contactPerson = '';
  email = '';
  phone = '';
  notes = '';
  formSubmitted = false;
  sent = false;

  get amount(): string {
    return this.isYearly ? this.plan.yearly : this.plan.monthly;
  }

  get period(): string {
    return this.isYearly ? '/Year' : '/Month';
  }

  get whatsappUrl(): string {
    const link = this.contactData.socialLinks.find((social: any) => social.name === 'whatsapp');
    const base = link?.url ?? `https://wa.me/${this.contactData.phone.replace(/\D/g, '')}`;
    const message =
      `Hi orderYaa, I want to buy the *${this.plan.name}* plan ` +
      `(${this.amount} PKR ${this.period}).\n\n` +
      `Company: ${this.companyName}\n` +
      `Contact person: ${this.contactPerson}\n` +
      `Email: ${this.email}\n` +
      `Phone: ${this.phone}` +
      (this.notes ? `\nNotes: ${this.notes}` : '');
    return `${base}?text=${encodeURIComponent(message)}`;
  }

  ngOnInit(): void {
    const planParam = this.route.snapshot.queryParamMap.get('plan');
    const cycleParam = this.route.snapshot.queryParamMap.get('cycle');
    if (planParam && PLAN_CATALOG[planParam]) {
      this.plan = PLAN_CATALOG[planParam];
    }
    this.isYearly = cycleParam === 'Yearly';

    this.seo.update({
      title: `Buy ${this.plan.name} Plan`,
      description: `Confirm your details to purchase the orderYaa ERP ${this.plan.name} plan and our sales team will get in touch on WhatsApp.`,
      path: '/buy-now',
    });
  }

  onSubmit(): void {
    this.formSubmitted = true;
    if (!this.companyName || !this.contactPerson || !this.email || !this.phone) {
      return;
    }
    window.open(this.whatsappUrl, '_blank');
    this.sent = true;
  }
}
